<template>
  <div class="disease-container" v-if="documentData">
    <div class="disease-container-header" @click="handleBack">返回报告首页</div>
    <div class="disease-container-disease">
      <div class="disease-container-disease-switch">
        <div class="home-content-switch">
          <div :class="{ selected: diseaseType === 'disease' }" class="home-content-switch-item"
            @click="handleChangeDiseaseType('disease')">
            <div class="home-content-switch-item-text" hover-class="none" :hover-stop-propagation="false">
              疾病风险
            </div>
            <div v-if="diseaseType === 'disease'" class="home-content-switch-item-line">
              <img class="home-content-switch-item-line-img" :src="`${imgHost2}/xzys_icon.png`" mode="aspectFit" />
            </div>
          </div>
          <div v-if="documentData.main_devg_detail.m07.cancer_risk.length > 0"
            :class="{ selected: diseaseType === 'cancer' }" class="home-content-switch-item"
            @click="handleChangeDiseaseType('cancer')">
            <div class="home-content-switch-item-text" hover-class="none" :hover-stop-propagation="false">
              癌症风险
            </div>
            <div v-if="diseaseType === 'cancer'" class="home-content-switch-item-line">
              <img class="home-content-switch-item-line-img" :src="`${imgHost2}/xzys_icon.png`" mode="aspectFit" />
            </div>
          </div>
        </div>
      </div>
      <div class="disease-container-disease-dc" v-if="diseaseType === 'disease'">
        <div v-for="item in disArr" :key="item.dis" :class="{ selected: curDisease === item.dis }"
          @click="handleSelectDisease(item.dis)">
          {{ item.devg }}
        </div>
      </div>
      <div class="disease-container-disease-dc" v-else-if="diseaseType === 'cancer'">
        <div v-for="item in disArr" :key="item.dis" :class="{ selected: curDisease === item.dis }"
          @click="handleSelectDisease(item.dis)">
          {{ item.devg }}
        </div>
      </div>
      <div class="disease-container-disease-dc" v-else></div>
    </div>
    <div class="disease-container-rate">
      <div class="detail-content-disease-rate" hover-class="none" :hover-stop-propagation="false">
        <div class="detail-content-disease-rate-box">
          <div class="label">未来1年的患病风险概率是：</div>
          <div class="value">
            <p>{{ personRates[0] || '' }}</p><span>%</span>
          </div>
          <div class="tip">
            <p>
              这代表平均每100个年龄、性别和健康状况与您相似的人中，有
              <span class="dis-rate">
                {{ personRates[0] || '' }}
              </span>
              个人将罹患
              <span class="dis-name text-red">
                {{ devg }}
              </span>
              。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="disease-container-content">
      <div class="disease-container-content-base">
        <div class="title">您的基本情况</div>
        <div class="content">
          <div class="detail-content-info mb-5" hover-class="none" :hover-stop-propagation="false">
            <div class="detail-content-info-base mb-5" hover-class="none" :hover-stop-propagation="false">
              <p v-if="documentData.base.age && Number(documentData.base.age) >= 65"
                class="detail-content-info-base-age" :selectable="false">
                65岁以上
              </p>
              <p v-else class="detail-content-info-base-age">65岁以下</p>
              <div class="detail-content-info-base-age-line" hover-class="none"></div>
              <p v-if="documentData.base.sex === '1'" class="detail-content-info-base-gender" :selectable="false">
                男
              </p>
              <p v-else class="detail-content-info-base-gender" :selectable="false">女</p>
            </div>
            <div v-if="documentData.main_devg_detail.bmi_whr === 1" class="detail-content-info-bmi normal"
              hover-class="none" :hover-stop-propagation="false">
              BMI/WHR正常
            </div>
            <div v-else class="detail-content-info-bmi danger" hover-class="none" :hover-stop-propagation="false">
              BMI/WHR超标
            </div>
          </div>
        </div>
      </div>
      <div class="disease-container-content-about">
        <div class="title">疾病相关症状</div>
        <div class="content">
          <disease-about v-if="diseaseType === 'disease'" :plan-data="planData" :curHea="curHea" />
          <cancelAbout v-else-if="diseaseType === 'cancer'" :plan-data="planData" />
        </div>
      </div>
      <div class="disease-container-content-plan">
        <div class="title">推荐营养保健方案</div>
        <div class="content" v-if="diseaseType === 'disease'">
          <health-hea1 v-if="curHea === 'HEA1'" :plan-data="planData" />
          <health-hea2 v-else-if="curHea === 'HEA2'" :plan-data="planData" />
          <health-hea3 v-else-if="curHea === 'HEA3'" :plan-data="planData" />
        </div>
        <div class="content" v-else-if="diseaseType === 'cancer'">
          <cancel-table :plan-data="planData" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getReportDetail } from '@/utils/axios';
import { imgHost2 } from '@/config';
import healthHea1 from '@/components/disease/health-hea1.vue'
import healthHea2 from '@/components/disease/health-hea2.vue'
import healthHea3 from '@/components/disease/health-hea3.vue'
import diseaseAbout from '@/components/disease/disease-about.vue'
import cancelAbout from '@/components/cancel/cancel-about.vue';
import cancelTable from '@/components/cancel/cancel-table.vue';

export default {
  name: 'llkjBackDetailDisease',
  components: {
    healthHea1,
    healthHea2,
    healthHea3,
    diseaseAbout, cancelAbout, cancelTable
  },
  data () {
    return {
      documentData: null,
      diseaseType: 'disease',
      curDisease: "",

      imgHost2,
    };
  },

  mounted () {
    const id = this.$route.query.id;
    console.log("detail page id: ", id);
    if (id) {
      this.getDetail(id);
    }
  },

  computed: {
    disArr () {
      let arr = []
      if (this.diseaseType === 'disease') {
        arr = this.documentData.main_devg_detail.m07.dis_risk
        this.curDisease = arr[0].dis
      } else {
        arr = this.documentData.main_devg_detail.m07.cancer_risk
        if (arr.length > 0) {
          this.curDisease = arr[0].dis
        }
      }
      return arr
    },
    personRates () {
      if (this.diseaseType === 'disease') {
        const dis_risk = this.documentData.main_devg_detail.m07.dis_risk.find(item => item.dis === this.curDisease)
        return dis_risk.person_rates || []
      } else if (this.diseaseType === 'cancer') {
        const cancer_risk = this.documentData.main_devg_detail.m07.cancer_risk.find(item => item.dis === this.curDisease)
        return cancer_risk.person_rates || []
      }
      return []

    },
    compareRates () {
      if (this.diseaseType === 'disease') {
        const dis_risk = this.documentData.main_devg_detail.m07.dis_risk.find(item => item.dis === this.curDisease)
        if (dis_risk) {
          return dis_risk.compare_rates || []
        }
      } else if (this.diseaseType === 'cancer') {
        const cancer_risk = this.documentData.main_devg_detail.m07.cancer_risk.find(item => item.dis === this.curDisease)
        if (cancer_risk) {
          return cancer_risk.compare_rates || []
        }
      }
      return []

    },
    planData () {
      let data = null
      if (this.diseaseType === 'disease') {
        data = this.documentData.main_devg_detail.dis_risk_plan[this.curDisease] || null

      } else if (this.diseaseType === 'cancer') {
        data = this.documentData.main_devg_detail.cancer_risk_plan[this.curDisease] || null
      }
      console.log("planData", data);

      return data
    },
    curHea () {
      return this.documentData.base.categ || ''
    },
    devg () {
      let arr = []
      if (this.diseaseType === 'disease') {
        arr = this.documentData.main_devg_detail.m07.dis_risk || []
      } else if (this.diseaseType === 'cancer') {
        arr = this.documentData.main_devg_detail.m07.cancer_risk || []
      }
      const cur = arr.find((item) => item.dis === this.curDisease)
      return cur.devg || ''
    }
  },

  methods: {
    getDetail (id) {
      getReportDetail({ id }).then(res => {
        if (res.code === 200) {
          const data = JSON.parse(window.atob(res.data));
          console.log(data);
          this.documentData = data;
          this.diseaseType = 'disease';
          this.curDisease = data.main_devg_detail.m07.dis_risk[0].dis || "";
        } else {
          console.log(res.msg);
        }
      })
    },
    handleBack () {
      this.$router.replace({ name: 'archivesDetailIndex', query: { id: this.$route.query.id } });
    },
    handleChangeDiseaseType (value) {
      this.diseaseType = value
    },
    handleSelectDisease (value) {
      this.curDisease = value
    }
  },
};
</script>



<style lang="scss" scoped>
.disease-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto 1fr;
  overflow: hidden;
  gap: 10px;
  padding: 10px;
  background-color: #F2F4FA;

  >div {
    position: relative;
    width: 100%;
    height: 100%;
  }

  &-header {
    background-color: #e2e2e2;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: bold;
    user-select: none;
    cursor: pointer;
    color: #000;
  }

  &-disease {

    .home-content-switch {
      position: relative;
      display: flex;
      z-index: 1;

      >div {
        font-weight: 600;
        font-size: 20px;
        color: #282A2C;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }

      &-item {
        position: relative;
        padding: 5px 10px;

        &-line {
          position: absolute;
          bottom: -11px;
          left: 50%;
          transform: translateX(-50%);
          width: 26px;
          height: 26px;
          z-index: -1;

          &-img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .selected {}
    }

    &-dc {
      position: relative;
      width: 100%;
      height: fit-content;
      padding-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: #282A2C;
      gap: 16px;
      user-select: none;
      overflow: hidden;
      overflow-x: auto;

      >div {
        position: relative;
        padding: 10px 20px;
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;
        cursor: pointer;
      }

      .selected {
        color: #fff;
        background: linear-gradient(225deg, #4EA4FF 0%, #4869FF 100%);
        border-radius: 10px 10px 10px 10px;
      }
    }
  }

  &-rate {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 0px 0px 0px 0px;

    .detail-content-disease-rate {
      position: relative;
      width: 100%;


      &-box {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-color: #cde5ff;
        border-radius: 10px;
        font-size: 16px;
        padding: 20px;
        gap: 10px;

        .label {
          font-weight: bold;

          margin-bottom: 10px;
        }

        .value {
          font-weight: bold;

          color: #2c50f2;
          display: flex;
          align-items: flex-end;

          >p {
            font-size: 20px;
          }
        }

        .tip {
          font-size: 14px;

          .dis-rate {
            font-weight: bold;

            color: #2c50f2;
          }

          .dis-name {
            font-weight: bold;
          }
        }
      }
    }
  }

  &-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas: "base plan" "about  plan";
    gap: 20px;
    overflow: hidden;

    >div {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 20px;
      background-color: #fff;
      border-radius: 8px;
      display: grid;
      grid-template-columns: 100%;
      grid-template-rows: auto 1fr;
      overflow: hidden;
      gap: 10px;

      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #282A2C;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .content {
        .detail-content-info {
          position: relative;
          width: 100%;
          height: 64px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: 100%;
          gap: 10px;
          background-color: #d7eefd;
          border-radius: 10px;
          padding: 6px;
          overflow: hidden;

          >div {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            font-size: 16px;
            font-weight: bold;
          }

          &-base {
            color: #282a2c;

            &-age-line {
              width: 2px;
              height: 20px;
              background-color: #bbbbbb;
            }
          }

          &-bmi {
            background-color: #fff;
            border-radius: 16rpx;
          }

          .normal {
            color: #2c50f2;
          }

          .danger {
            color: #fd473f;
          }
        }

      }

    }



    &-base {
      grid-area: base;
      display: flex;
    }

    &-plan {
      grid-area: plan;
    }

    &-about {
      grid-area: about;
    }
  }
}
</style>